import React from "react";
import { Box, Button } from "@mui/material";
import DynamicTable from "../CommonComponents/Table/DynamicTable";
import { getCustomWriteAccess } from "../CommonComponents/Common";
import { useSelector } from "react-redux";
import BaseButton from "../Common/Buttons/BaseButton";
import { ReactComponent as ArrowBack } from "../../../assets/icons/arrow-back.svg";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const ViewAudience = ({
  toggleViewList,
  deleteData,
  audienceData,
  setShowContactDelete,
  headerList,
}) => {
  const reducer: any = useSelector((state: any) => state);

  return (
    <Box sx={{ position: "relative" }}>
      <Box className="viewlist-btn-container flex-end gap-2 mb-2">
        {getCustomWriteAccess(reducer) === "write" && (
          <BaseButton
            title="Delete"
            variant="contained"
            handleClick={() => setShowContactDelete(true)}
            disabled={audienceData?.length <= 1}
          />
        )}
        <BaseButton
          title="Back"
          variant="contained"
          handleClick={toggleViewList}
          startIcon={<ArrowBack className="back-icon" />}
        />
      </Box>
      <DynamicTable
        columns={[
          {
            label: "#",
            render: (row) => (
              <input
                onChange={(e) => deleteData(e.target.checked, row.phone)}
                type="checkbox"
              />
            ),
            styles: { padding: 2 },
          },
          {
            label: "FIRST NAME",
            field: "firstName",
          },
          {
            label: "LAST NAME",
            field: "lastName",
          },
          {
            label: "PHONE NUMBER",
            field: "phone",
          },
          ...headerList?.map((header) => ({
            label: header,
            render: (row) => row[header] || "--",
          })),
        ]}
        data={audienceData}
        noDataAvailableMessage={"No Audiences Available"}
        rowCount={audienceData?.length}
      />
    </Box>
  );
};

export default ViewAudience;
